var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVan = function SvgVan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.875 3.125h8.75l3.75 3.75V10h-1.563a1.877 1.877 0 0 1-1.874 1.875A1.877 1.877 0 0 1 9.062 10H5.626a1.877 1.877 0 0 1-1.875 1.875A1.877 1.877 0 0 1 1.875 10H.625V4.375c0-.694.563-1.25 1.25-1.25zm0 1.25v2.5h2.5v-2.5h-2.5zm1.875 6.563A.936.936 0 0 1 2.812 10c0-.519.42-.938.938-.938.519 0 .938.42.938.938a.936.936 0 0 1-.938.938zm1.875-4.063h2.5v-2.5h-2.5v2.5zm5.313 4.063A.936.936 0 0 1 10 10c0-.519.419-.938.938-.938.518 0 .937.42.937.938a.936.936 0 0 1-.938.938zM9.374 4.375v2.5H12.5l-2.5-2.5h-.625z"
  }))));
};
export default SvgVan;